import { Link } from "react-router-dom"; 
import { Twitter, Linkedin } from "react-feather"; 

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-10">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Logo & Branding */}
          <div className="text-center md:text-left mb-6 md:mb-0">
            <Link to="/" className="text-2xl font-bold text-white">
              parmazing<span className="text-yellow-500">.</span>
            </Link>
            <p className="text-sm text-gray-400 mt-2">
              Inspiring Digital Marketing & Creativity
            </p>
          </div>

          {/* Social Media Links */}
          <div className="flex space-x-4 mt-6 md:mt-0">
            <SocialLink 
              href="https://x.com/sudeepgupta?utm_source=website&utm_medium=website&utm_campaign=Footer-links&utm_content=twitter" 
              icon={<Twitter size={20} />} 
            />

            <SocialLink 
              href="https://www.linkedin.com/in/sudeepguptaa/?utm_source=website&utm_medium=website&utm_campaign=Footer-links&utm_content=linkedin" 
              icon={<Linkedin size={20} />} 
            />
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 my-6"></div>

        {/* Footer Links Row */}
        <div className="flex flex-col md:flex-row justify-center md:justify-between items-center text-sm text-gray-500">
          <div className="mb-4 md:mb-0">
            © {new Date().getFullYear()} Parmazing. All Rights Reserved.
          </div>

          <div className="flex space-x-6">
            <FooterLink to="/privacy" label="Privacy Policy" />
            <FooterLink to="/terms-of-use" label="Terms of Use" />
          </div>
        </div>
      </div>
    </footer>
  );
};

// Reusable Footer Link Component
const FooterLink = ({ to, label }) => (
  <Link
    to={to}
    className="text-gray-400 hover:text-yellow-500 transition text-sm"
  >
    {label}
  </Link>
);

// Reusable Social Media Icon Component
const SocialLink = ({ href, icon }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="text-gray-400 hover:text-yellow-500 transition"
  >
    {icon}
  </a>
);

export default Footer;
